import SEO from '../components/common/SEO';
import './Careers.css';

const Careers = () => {
  return (
    <div className="careers-page">
      <SEO
        title="Careers"
        description="Join the team at Essentick. Explore career opportunities in the premium watch and lifestyle industry in Nepal."
        keywords="careers, jobs Nepal, Essentick jobs, hiring"
      />
      <h1 className="careers-title">Careers at Essentick</h1>
      <p className="careers-subtitle">We&apos;re not hiring right now.</p>
      <p className="careers-text">
        There are currently no open positions. Please check back later or follow us on social media
        to be the first to know about future opportunities.
      </p>
    </div>
  );
};

export default Careers;

